exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SavedCardToPlainFieldsSwitch_savedCardToPlainFieldsSwitch_PkoXE{text-transform:uppercase;font-size:11px;line-height:18px;font-weight:500;cursor:pointer}body[style*=\"direction: rtl\"] .SavedCardToPlainFieldsSwitch_savedCardToPlainFieldsSwitch_PkoXE>svg{-webkit-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"savedCardToPlainFieldsSwitch": "SavedCardToPlainFieldsSwitch_savedCardToPlainFieldsSwitch_PkoXE"
};